<template>
  <header class="header-area header-sticky">
    <div class="container">
      <nav class="main-nav">
        <!-- BOUTON BURGER -->
        <button class="burger-menu" @click="toggleMenu" :aria-expanded="menuOpen" aria-label="Menu principal">
          <span :class="{ open: menuOpen }"></span>
          <span :class="{ open: menuOpen }"></span>
          <span :class="{ open: menuOpen }"></span>
        </button>

        <!-- Logo pour mobile + Accès Client juste en dessous, toujours visible -->
        <div class="mobile-logo">
          <router-link to="/" @click="closeMenu">
            <img src="@/assets/logo.png" alt="patrimonea by Gwem" class="brand-logo" />
          </router-link>
          <router-link v-if="contactItem" :to="contactItem.path" class="mobile-topbar-cta">
            {{ contactItem.label }}
          </router-link>
        </div>

        <!-- Mobile menu : téléporté dans <body> pour éviter tout conflit de z-index / stacking-context -->
        <teleport to="body">
          <!-- NAVIGATION MOBILE -->
          <div v-if="menuOpen" class="mobile-nav-container" role="dialog" aria-modal="true" aria-label="Menu principal">
              <div class="mobile-nav-overlay">
                <!-- En-tête du menu mobile -->
                <div class="mobile-nav-header">
                  <button class="close-menu-btn" @click="closeMenu" aria-label="Fermer le menu">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                      <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                  </button>
                  <div class="mobile-nav-logo">
                    <router-link to="/" @click="closeMenu">
                      <img src="@/assets/logo.png" alt="patrimonea by Gwem" class="brand-logo" />
                    </router-link>
                  </div>
                </div>

                <!-- Accès Client : juste sous le logo, séparé du reste du menu -->
                <router-link
                  v-if="contactItem"
                  :to="contactItem.path"
                  class="mobile-nav-link contact mobile-nav-link--top"
                  :class="{ active: isActive(contactItem.path) }"
                  @click="closeMenu"
                >
                  <span class="mobile-nav-icon" v-if="contactItem.icon">
                    <i :class="contactItem.icon"></i>
                  </span>
                  <span class="mobile-nav-text">{{ contactItem.label }}</span>
                  <span class="mobile-nav-arrow">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </span>
                </router-link>

                <!-- Menu principal -->
                <ul class="mobile-nav">
                  <li class="mobile-nav-item" v-for="(item, index) in regularMenuItems" :key="item.path">
                    <router-link
                      :to="item.path"
                      class="mobile-nav-link"
                      :class="{
                        'active': isActive(item.path),
                        'contact': item.contact
                      }"
                      @click="closeMenu"
                    >
                      <span class="mobile-nav-icon" v-if="item.icon">
                        <i :class="item.icon"></i>
                      </span>
                      <span class="mobile-nav-text">{{ item.label }}</span>
                      <span class="mobile-nav-arrow">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </span>
                      </router-link>
                  </li>
                </ul>
              </div>
            </div>
        </teleport>

        <!-- Logo pour desktop -->
        <div class="desktop-logo">
          <router-link to="/">
            <img src="@/assets/logo.png" alt="patrimonea by Gwem" class="brand-logo" />
          </router-link>
        </div>

        <!-- NAVIGATION DESKTOP -->
        <ul class="desktop-nav">
          <li class="nav-item" v-for="item in menuItems" :key="item.path">
            <router-link 
              :to="item.path" 
              class="nav-link"
              :class="{ 
                'active': isActive(item.path),
                'btn-contact': item.contact
              }"
              :aria-current="isActive(item.path) ? 'page' : undefined"
              @click="closeMenu"
            >
              <span class="nav-text">{{ item.label }}</span>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: "AppHead",
  data() {
    return {
      menuOpen: false,
      menuItems: [
        { label: "Accueil", path: "/", icon: "fas fa-home" },
        { label: "Notre Approche", path: "/approche", icon: "fas fa-bullseye" },
        { label: "La Plateforme", path: "/platforme", icon: "fas fa-desktop" },
        { label: "Nous contacter", path: "/nous-contacter", icon: "fas fa-envelope"},
        { label: "Accès Client", path: "/connexion", icon: "fas fa-user", contact: true  }
      ]
    };
  },
  computed: {
    contactItem() {
      return this.menuItems.find((item) => item.contact) || null;
    },
    regularMenuItems() {
      return this.menuItems.filter((item) => !item.contact);
    },
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      document.body.classList.toggle('menu-open', this.menuOpen);
    },
    closeMenu() {
      this.menuOpen = false;
      document.body.classList.remove('menu-open');
    },
    isActive(path) {
      return this.$route.path === path;
    },
  },
  watch: {
    $route() {
      this.closeMenu();
    }
  }
};
</script>

<style scoped>
.header-area {
  position: sticky;
  top: 0;
  z-index: 2147483000;
  background: var(--paper);
  border-bottom: 1px solid var(--line);
  box-shadow: none;
  backdrop-filter: blur(10px);
  padding: 0;
  height: 76px;
  display: flex;
  align-items: center;
  transition: background var(--dur-base) var(--ease), box-shadow var(--dur-base) var(--ease);
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--space-5);
  width: 100%;
}

.main-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 76px;
  width: 100%;
  gap: var(--space-4);
}

.desktop-logo {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-right: var(--space-4);
}

.brand-logo {
  width: clamp(140px, 16vw, 200px);
  height: auto;
  display: block;
  object-fit: contain;
}

.mobile-logo .brand-logo {
  width: clamp(120px, 42vw, 160px);
}

.desktop-nav {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 2px;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  margin-left: auto;
  min-width: 0;
}

.nav-item {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--brand-navy);
  background-color: transparent;
  text-decoration: none;
  font-family: var(--font-body);
  font-weight: 500;
  font-size: 0.875rem;
  transition: color var(--dur-base) var(--ease);
  white-space: nowrap;
  height: 40px;
  position: relative;
  overflow: visible;
  border-radius: 0;
  padding: var(--space-2) 10px;
  min-width: 0;
}

.nav-link::after {
  content: "";
  position: absolute;
  left: 10px;
  right: 100%;
  bottom: 4px;
  height: 2px;
  background: var(--brand-brown);
  transition: right var(--dur-base) var(--ease);
}

.nav-text {
  position: relative;
  z-index: 1;
  font-size: 0.875rem;
}

.nav-link:not(.btn-contact):hover::after,
.nav-link.active:not(.btn-contact)::after {
  right: 10px;
}

.nav-link.active:not(.btn-contact) {
  font-weight: 600;
  background: transparent;
  border: none;
}

.btn-contact {
  background: var(--brand-red);
  border: 1px solid var(--brand-red);
  color: var(--paper);
  font-weight: 600;
  margin-left: 8px;
  border-radius: var(--radius-pill);
  box-shadow: none;
  letter-spacing: 0.04em;
  text-transform: none;
  font-size: 0.8125rem;
  padding-inline: 16px;
  height: 40px;
}

.btn-contact::after {
  display: none;
}

.btn-contact:hover {
  background: var(--brand-red-light);
  border-color: var(--brand-red-light);
  color: var(--paper);
  transform: none;
}

/* Masquer le menu desktop sur mobile */
@media screen and (max-width: 768px) {
  .desktop-nav {
    display: none;
  }
  
  .desktop-logo {
    display: none;
  }
}

/* LOGO MOBILE */
.mobile-logo {
  display: none;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
}

.mobile-topbar-cta {
  display: none;
  align-items: center;
  justify-content: center;
  background: var(--brand-red);
  color: var(--paper);
  font-weight: 600;
  font-size: 0.6875rem;
  letter-spacing: 0.03em;
  text-decoration: none;
  padding: 3px 12px;
  border-radius: var(--radius-pill, 999px);
  white-space: nowrap;
}

/* BURGER MENU AMÉLIORÉ */
.burger-menu {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 12px;
  border-radius: 8px;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
  z-index: 1001;
  transform: translateZ(0);
  -webkit-tap-highlight-color: transparent;
}

.burger-menu:hover {
  background: color-mix(in srgb, var(--bank-gold) 10%, transparent);
}

.burger-menu:focus {
  outline: none;
}

.burger-menu:focus-visible {
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--bank-gold) 35%, transparent);
}

.burger-menu span {
  width: 24px;
  height: 2px;
  background: var(--bank-navy);
  border-radius: 2px;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: center;
}

/* Animation burger -> croix améliorée */
.burger-menu span.open:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
  background: var(--bank-navy);
}
.burger-menu span.open:nth-child(2) {
  opacity: 0;
  transform: scale(0);
}
.burger-menu span.open:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
  background: var(--bank-navy);
}

/* MENU MOBILE AMÉLIORÉ */
.mobile-nav-container {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 320px;
  max-width: 85vw;
  background: var(--paper);
  box-shadow: var(--shadow-2xl);
  z-index: 2147483001;
  overflow-y: auto;
  border-right: 1px solid var(--line);
}

.mobile-nav-overlay {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}

/* HEADER DU MENU MOBILE */
.mobile-nav-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--line);
  margin-bottom: 20px;
}

.close-menu-btn {
  background: transparent;
  border: none;
  color: var(--brand-navy);
  cursor: pointer;
  padding: 8px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.close-menu-btn:hover {
  background: var(--surface);
  transform: rotate(90deg);
}

/* MENU PRINCIPAL MOBILE */
.mobile-nav {
  list-style: none;
  margin: 0;
  padding: 0;
  flex: 1;
}

.mobile-nav-item {
  margin-bottom: 8px;
}

.mobile-nav-link {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  color: var(--brand-navy);
  text-decoration: none;
  border-radius: 12px;
  background: var(--surface);
  border: 1px solid transparent;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.mobile-nav-link::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, color-mix(in srgb, var(--bank-gold) 18%, transparent), transparent);
  transition: left 0.6s ease;
}

.mobile-nav-link:hover::before {
  left: 100%;
}

.mobile-nav-link:hover {
  background: color-mix(in srgb, var(--brand-navy) 6%, transparent);
  border-color: var(--line);
  transform: translateX(8px);
}

.mobile-nav-link.active {
  background: var(--brand-gold-soft);
  border-color: color-mix(in srgb, var(--brand-gold) 40%, transparent);
}

.mobile-nav-link.active .mobile-nav-text {
  color: var(--brand-navy);
  font-weight: 600;
}

.mobile-nav-link.contact {
  background: var(--brand-red);
  border: 1px solid var(--brand-red);
  margin-top: 10px;
  font-weight: 600;
  color: var(--paper);
}

.mobile-nav-link--top {
  margin-top: 0;
  margin-bottom: 20px;
}

.mobile-nav-link.contact .mobile-nav-icon,
.mobile-nav-link.contact .mobile-nav-arrow {
  color: var(--paper);
}

.mobile-nav-link.contact:hover {
  background: var(--brand-red-light);
  border-color: var(--brand-red-light);
  transform: translateX(8px);
  color: var(--paper);
}

.mobile-nav-icon {
  width: 24px;
  margin-right: 16px;
  color: var(--bank-navy);
  opacity: 0.8;
}

.mobile-nav-text {
  flex: 1;
  font-size: 1.1rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

.mobile-nav-arrow {
  color: var(--muted);
  transition: all 0.3s ease;
}

.mobile-nav-link:hover .mobile-nav-arrow {
  color: var(--bank-gold-light);
  transform: translateX(4px);
}

/* RESPONSIVE MOBILE */
@media screen and (max-width: 768px) {
  .burger-menu {
    display: flex;
    position: absolute;
    left: 16px;
    top: 50%;
    transform: translateY(-50%);
  }

  .mobile-logo {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  .mobile-topbar-cta {
    display: inline-flex;
  }

  .header-area {
    height: auto;
    padding: 10px 0;
  }

  .container {
    position: relative;
  }

  .main-nav {
    min-height: 84px;
    justify-content: space-between;
  }
}

@media screen and (max-width: 480px) {
  .mobile-nav-container {
    width: 280px;
  }

  .mobile-nav-overlay {
    padding: 16px;
  }

  .mobile-nav-link {
    padding: 14px 16px;
  }

  .mobile-nav-text {
    font-size: 1rem;
  }
}

/* Animation d'entrée des items */
@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.mobile-nav-item {
  animation: slideInRight 0.4s ease-out forwards;
  opacity: 0;
}

.mobile-nav-item:nth-child(1) { animation-delay: 0.1s; }
.mobile-nav-item:nth-child(2) { animation-delay: 0.15s; }
.mobile-nav-item:nth-child(3) { animation-delay: 0.2s; }
.mobile-nav-item:nth-child(4) { animation-delay: 0.25s; }
.mobile-nav-item:nth-child(5) { animation-delay: 0.3s; }

/* Empêcher le scroll du body quand le menu est ouvert */
body.menu-open {
  overflow: hidden;
}
</style>
